const errorDictionary: Record<string, string> = {
    // User errors
    "User already exists": "Ya existe un usuario con este nombre.",
    "Username or password are incorrect": "Usuario o contraseña incorrectos.",
    "Invalid session": "Tu sesión ha caducado. Vuelve a iniciar sesión.",
    "Invalid role": "Error de autenticación.",
    "Dietician does not have an assigned office": "El dietista no tiene un consultorio asignado.",
    "Permission not found": "Error de autenticación.",
    "User not found": "Usuario no encontrado.",
    "User is blocked": "El usuario no tiene acceso a la plataforma.",
    "Office is inactive": "El consultorio está deshabilitado.",
    "Unauthorized": "No tienes permiso para realizar esta acción.",
    "Username is required. ": "El nombre de usuario es obligatorio.",
    "Password is required. ": "La contraseña es obligatoria.",
    "Role is required. ": "El rol es obligatorio.",
    "Name is required. ": "El nombre es obligatorio.",
    "Last name is required. ": "El apellido paterno es obligatorio.",
    "Phone is required. ": "El número de teléfono es obligatorio.",
    "Phone must have 10 digits": "El número de teléfono debe tener 10 dígitos.",
    "Email is required. ": "El correo electrónico es obligatorio.",
    "Invalid email format": "Formato de correo electrónico inválido.",
    "Birthdate is required. ": "La fecha de nacimiento es obligatoria.",
    "Permissions are required. ": "Los permisos son obligatorios.",
    "User is not a dietician": "El usuario no es un dietista.",
    "User is not active": "El usuario está deshabilitado.",
    "Renovation date is required. ": "La fecha de renovación es obligatoria.",
    "Renovation date must be in the future": "La fecha de renovación debe ser en el futuro.",

    // Balance errors
    "Amount is required. ": "La cantidad es obligatoria.",
    "Amount must be greater than or equal to 1": "La cantidad debe ser mayor o igual a $1.",
    "Amount must be less than or equal to 10000": "La cantidad debe ser menor o igual a $10,000.",

    // Pagination errors
    "Page is required. ": "La página es obligatoria.",
    "Page must be greater than or equal to 0": "La página debe ser mayor o igual a 1.",
    "Size is required. ": "El tamaño de página es obligatorio.",
    "Size must be greater than or equal to 1": "El tamaño de página debe ser mayor o igual a 1.",
    "Size must be less than or equal to 100": "El tamaño de página debe ser menor o igual a 100.",

    // Catalog errors
    "Beverage already exists": "Ya existe esta bebida.",
    "Beverage not found": "Bebida no encontrada.",
    "Ailment already exists": "Ya existe este padecimiento.",
    "Ailment not found": "Padecimiento no encontrado.",
    "Medication already exists": "Ya existe este medicamento.",
    "Medication not found": "Medicamento no encontrado.",
    "Diet not found": "Dieta no encontrada.",
    "Diet already exists": "Ya existe esta dieta.",

    // Office errors
    "Office ID is required. ": "El identificador del consultorio es obligatorio.",
    "Office already exists": "Ya existe este consultorio.",
    "Office not found": "Consultorio no encontrado.",
    "Code is required. ": "El código es obligatorio.",
    "Code must be between 4 and 8 characters": "El código debe tener entre 4 y 8 caracteres.",
    "Province is required. ": "La provincia es obligatoria.",
    "City is required. ": "La ciudad es obligatoria.",
    "District is required. ": "La colonia es obligatoria.",
    "Street is required. ": "La calle es obligatoria.",
    "Status is required. ": "El estatus es obligatorio.",
    "No available offices": "No hay consultorios disponibles.",
    "No available dieticians": "No hay dietistas disponibles para asignar. Asegúrate de que haya dietistas activos sin consultorio asignado.",

    // Clients errors
    "Client ID is required. ": "El identificador del cliente es obligatorio.",
    "Client name is required. ": "El nombre del cliente es obligatorio.",
    "Client type is required. ": "El tipo de cliente es obligatorio.",
    "Client not found": "No se encontró al cliente.",
    "Client is not validated": "El expediente no ha sido validado aún. Ponte en contacto con un administrador.",

    // Quantity table errors
    "Quantity table not found": "Tabla de cantidades no encontrada.",
    "Percentage is required. ": "El porcentaje es obligatorio.",
    "Percentage must be at least 1%. ": "El porcentaje debe ser al menos 1%.",
    "Percentage must be at most 98%. ": "El porcentaje debe ser como máximo 98%.",
    "Insufficient balance to create the quantity table": "Saldo insuficiente para generar la tabla de cantidades. Recarga tu saldo e intenta de nuevo.",
    "Level must be at least 1. ": "El nivel debe ser al menos 1.",
    "Level cannot be null. ": "El nivel es obligatorio.",
    "Notes cannot exceed 255 characters": "Las notas no pueden exceder los 255 caracteres.",
    "Cannot create control table": "No se puede generar la tabla de control con el peso actual del cliente.",
    "Cannot create maintenance table": "No se puede generar la tabla de mantenimiento con el peso actual del cliente.",
    "Cannot create ABC table at this level": "No se puede generar la tabla ABC debido a un nivel de transición próximo.",
    "Has eaten state is required. ": "El estado de si el cliente ha comido o no es obligatorio.",

    // Password reset errors
    "Error while sending password reset email": "Ocurrió un error al enviar el correo de restablecimiento de contraseña. Intenta de nuevo más tarde.",
    "Token is required. ": "El token es obligatorio.",
    "New password is required. ": "La nueva contraseña es obligatoria.",
    "Token is invalid": "El enlace de restablecimiento de contraseña ya no es válido. Intenta solicitar un nuevo enlace.",
    "Token has expired": "El enlace de restablecimiento de contraseña ha expirado. Intenta solicitar un nuevo enlace.",
}

export const getErrorMessage = (error: string): string => {
    return errorDictionary[error] || "Ocurrió un error inesperado. Contacta al soporte técnico.";
}
